// Grab Fields to pass onto SLACK for more CONTEXT
function getSlackFields(req) {
  try {
    const { customerId, requestId } = req
    const referer = req.get('Referrer') || 'Unknown ( direct api call )'
    const userAgent = req.get('User-Agent')
    const path = req.path || 'Unknown'
    const botTraffic = req.isBotTraffic ? 'Bot' : 'User'
    return [
      {
        title: 'User Agent',
        value: userAgent,
        short: true,
      },
      {
        title: 'User Info',
        value: `${botTraffic} - ${customerId}`,
        short: true,
      },
      {
        title: 'URL Path',
        value: path,
        short: true,
      },
      {
        title: 'Request ID',
        value: requestId,
        short: true,
      },
      referer
        ? {
            title: 'Http-Referrer',
            value: referer,
            short: true,
          }
        : null,
    ].filter(Boolean)
  } catch (error) {
    console.error({ error })
    return {}
  }
}

module.exports = { getSlackFields }
